import React, { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { InvoiceSummaryDto } from 'src/generated/services/TFinancialApi';
import { invoiceAndDisputeDetailsToDisputeFormValues } from 'src/utils/disputeMapper';
import { FormContainer } from '../../forms/FormContainer';
import { validationSchema } from './formValidationSchema';
import { DisputeSummary } from './Summary';
import { IDisputeFormValues } from './types';

interface IDisputeResultProps {
  invoiceSummary: InvoiceSummaryDto;
}

export const DisputeResult: React.FC<IDisputeResultProps> = (props) => {
  const { invoiceSummary } = props;
  const resultData = useMemo(() => invoiceAndDisputeDetailsToDisputeFormValues(invoiceSummary), [invoiceSummary]);

  const formContext = useForm({
    defaultValues: resultData as IDisputeFormValues,
    resolver: yupResolver(validationSchema),
  });

  return (
    <FormContainer formContext={formContext} onSuccess={() => {}} FormProps={{ className: 'min-h-full flex flex-col overflow-y-auto pb-60' }}>
      <DisputeSummary isHideHeader values={resultData} invoiceSummary={invoiceSummary} />
    </FormContainer>
  );
};
